import angular from 'angular'

import myInvoiceForm from './directives/form/myInvoiceForm'

import invoicingLabels from './resources/labels.resource'
import invoicingFields from './resources/fields.resource'
import invoicingIcons from './resources/icons.resource'

const name = 'invoicingModule'

angular.module(name, [])
  .directive('myInvoiceForm', myInvoiceForm)
  .service('invoicingLabels', invoicingLabels)
  .service('invoicingFields', invoicingFields)
  .service('invoicingIcons', invoicingIcons)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/invoicing/invoicing.module.js